<div class="project-members" data-automation-id="project-members-container">
    <div class="header-bar" data-automation-id="project-members-header">
        <button type="button" data-automation-id="project-members-save-button" class="primary-button"
            (click)="saveChanges()" [disabled]="isDisabled()" *ngIf="hasPermission">Save</button>
        <button type="button" data-automation-id="project-members-discard-changes-button" class="secondary-button"
            (click)="discardChanges()" [disabled]="isDisabled()" *ngIf="hasPermission">Discard Changes</button>
        <button type="button" class="help-button" data-automation-id="project-members-help-button'"
            (click)="openHelp()"><i class="fa fa-question"></i></button>
    </div>
    <div class="add-remove-button-bar" [ngClass]="[!hasPermission ? 'add-remove-button-bar-disabled' : '']">
        <button type="button" data-automation-id="project-members-add-remove-members-button" class="secondary-button"
            [disabled]="isBusy || genericGrid?.isBusy || genericGrid?.filters?.length > 0" (click)="editMembers()"
            *ngIf="hasPermission">
            <i class="fa fa-pencil"></i>Add / Remove Members ...
        </button>
    </div>
    <div class="content" data-automation-id="project-members-content" [resBusySpinner]="isBusy"
        [message]="isBusyMessage">
        <res-generic-grid gridName="Members" [automationId]="automationId" [pagerVisible]="false" [rowHeight]="50"
            [columnDefs]="columnDefs" [requestInfo]="requestInfo" [gridContext]="gridContext"
            [responseCallback]="responseCallback" [rowClassRules]="rowClassRules"
            [loadDataFinishedCallback]="loadDataFinishedCallback">
        </res-generic-grid>
    </div>
</div>